import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 25 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#757575",
      "fill-rule": "evenodd",
      d: "M15.86 6.996a8.6 8.6 0 0 0-1.45-.158c-1.043 0-1.11.453-1.11 1.178v1.292h2.606l-.228 2.674H13.3v8.136h-3.263v-8.136H8.358V9.308h1.678V7.653c0-2.266 1.065-3.535 3.739-3.535.929 0 1.609.136 2.493.317z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }